<template>
<el-dialog title="发送短信" :visible.sync="dialogVisible" width="800px" center destroy-on-close append-to-body @close="handleClose">
    <el-form label-position="right" label-width="100px" :model="logForm" class="pr_20">
        <el-form-item label="类型：">
            <div class="_flex _f_ai">
                <el-radio v-model="logForm.use_template" label="1">模板</el-radio>
                <el-select v-model="logForm.template_id" class="w_100" placeholder="请选择"
                    @visible-change="e => getTemplateLists()" @change="changeTemplate"
                    style="width: 300px;margin-right: 20px;">
                    <el-option v-for="(item,index) in templateArr" :key="index" :label="item.title" :value="item.id">
                    </el-option>
                </el-select>
                <el-radio v-model="logForm.use_template" label="0">自定义</el-radio>
            </div>
        </el-form-item>
        <el-form-item label="内容：">
            <el-input type="textarea" v-model="logForm.content" :rows="5" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="客户：">
            <el-select v-model="logForm.tmp_ids" multiple filterable clearable remote reserve-keyword placeholder="请输入手机号" :remote-method="remoteMethod" :loading="loading" style="width: 300px;margin-right: 20px;" >
                <el-option v-for="item in localUserArr" :key="item.id" :label="item.name + '/' + item.phone" :value="item.id"> </el-option>
            </el-select>
            <el-button type="primary" size="small" @click="join">加入发送</el-button>
            <div class="_flex_sb _f_ai red">已选 {{logForm.users.length}}</div>
        </el-form-item>
        <div class="_flex _f_fw _scroll ml_80" style="min-height: 100px;max-height: 200px;">
            <div class="_flex_sb _f_ai f_12 p_5 mr_10 mt_10 w_25 bag_d br_6 c0 h20" v-for="i in logForm.users">
                {{i.name}} {{i.phone}}
                <i class="el-icon-circle-close f_18" @click="remove(i.id)"></i>
            </div>
        </div>
    </el-form>
    <span slot="footer">
        <el-button type="" @click="handleClose">取 消</el-button>
        <el-button type="success" v-if="logForm.state == 1" :loading="submitloading" @click="submitLog">确 定</el-button>
        <el-button type="danger" v-if="logForm.state == 1" :loading="sendloading" @click="send">发送短信</el-button>
    </span>
</el-dialog>
</template>

<script>
    import { articleLists, articleDetail, smbao, smslogAdd, smslogEdit, smsSend, userLists } from "@/request/apis.js"
    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            userArr: {
                type: Array,
                default: () => []
            },
            formDate: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                templateArr: [],
                logFormInit: {},
                logForm: {
                    id: '',
                    use_template: '1',
                    template_id: '',
                    content: '',
                    tmp_ids: [],
                    users: [],
                    consumer_ids: [],
                    state: 1,
                },
                loading: false,
                localUserArr: [],
                submitloading: false,
                sendloading: false,
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.visible;
                },
                set(val) {
                    this.$emit('close');
                }
            }
        },
        created() {
            console.log('Smssend created', this.userArr, this.formDate);
            this.localUserArr = [...this.userArr];
            
            // 初始化 logForm，合并 formDate 数据
            this.logForm = {
                ...this.logForm,
                ...this.formDate, // 合并传入的表单数据
                users: [...this.userArr]
            };
        },
        watch: {
            userArr: {
                handler(newVal) {
                    console.log('userArr changed', newVal);
                    this.localUserArr = [...newVal];
                    this.logForm.users = [...newVal];
                },
                immediate: true
            },
            visible(newVal) {
                if(newVal) {
                    this.logForm.users = [...this.userArr];
                    this.localUserArr = [...this.userArr];
                }
            },
            formDate: {
                handler(newVal) {
                    console.log('formDate changed', newVal);
                    // 当 formDate 变化时更新 logForm
                    this.logForm = {
                        ...this.logForm,
                        ...newVal,
                        users: [...this.userArr] // 保持用户列表
                    };
                },
                deep: true
            }
        },
        mounted() {
            console.log('Smssend mounted', this.userArr, this.formDate)
            this.logFormInit = { ...this.logForm };
            this.templateFormInit = { ...this.templateForm };
            this.getTemplateLists();
        },
        methods: {
            async remoteMethod(query) {
                console.log('query', query);
                let params = {phone: query || ''};
                this.loading = true;
                let res = await userLists(params);
                this.loading = false;
                this.localUserArr = res.data;
            },
            join(){
                console.log('join', this.logForm.tmp_ids, this.logForm.consumer_ids);
                this.logForm.tmp_ids.forEach(userId => {
                    let user = this.localUserArr.find(user => user.id == userId);
                    if(!this.logForm.users.includes(user)){
                        this.logForm.users.push(user);
                    }
                });
                this.logForm.tmp_ids = [];
            },
            async getTemplateLists(page){
                let res = await articleLists({type: 3, limit: 1000});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.templateArr = res.data;
            },
            async changeTemplate(){
                if(this.logForm.template_id){
                    this.templateArr.forEach(async template => {
                        if(template.id == this.logForm.template_id){
                            let res = await articleDetail({id: template.id});
                            if (res.code != 0) {
                                return this.$message.error(res.msg);
                            }
                            this.logForm.content = res.data.content;
                        }
                    });
                }
            },
            async submitLog(){
                if(this.logForm.users.length == 0){
                    return this.$message.error('请选择客户');
                }
                let res;
                let params = {...this.logForm, consumer_ids: this.logForm.users.map(user => user.id)};
                this.submitloading = true;
                if(this.logForm.id){
                    res = await smslogEdit(params);
                }else{
                    res = await smslogAdd(params);
                }
                this.submitloading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.handleClose();
            },
            async send(){
                if(this.logForm.users.length == 0){
                    return this.$message.error('请选择客户');
                }
                this.$confirm('当前即将发送短信, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.sendloading = true;
                    let res = await smsSend({...this.logForm, consumer_ids: this.logForm.users.map(user => user.id)});
                    this.sendloading = false;
                    if (res.code != 0) {
                        return this.$message.error(res.msg);
                    }
                    this.$message.success(res.msg);
                    this.handleClose();
                }).catch(() => { });
            },
            handleClose() {
                this.$emit('close');
                this.logForm = { ...this.logFormInit };
                this.logForm.users = [...this.userArr];
            },
            remove(id) {
                this.logForm.users = this.logForm.users.filter(user => user.id !== id);
            },
        }
    }
</script>